/**
 * AuroraFrame — the edge-line gradient (indigo → violet → green) as a thin
 * frame that slowly turns around its content, with a faint matching halo.
 * Web: an oversized conic gradient behind the content, clipped to the frame
 * and rotated with a transform (compositor only, no repaint per frame).
 * Native and reduced motion: a static gradient frame.
 *
 *   <AuroraFrame radius={21}><Card /></AuroraFrame>
 */
import React from 'react';
import { View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { IS_WEB, useReducedMotion } from '../../utils/motion';
import injectCss from '../../utils/injectCss';

const CSS = `
[data-aurora] { position: relative; overflow: hidden; isolation: isolate; box-shadow: 0 0 0 1px rgba(255,255,255,0.02), 0 30px 80px -30px rgba(99,102,241,0.55); }
[data-aurora]::before { content: ''; position: absolute; z-index: -1; left: 50%; top: 50%; width: 160%; aspect-ratio: 1; translate: -50% -50%;
  background: conic-gradient(#6366F1, #8B5CF6, #34D399, #8B5CF6, #6366F1); }
[data-aurora="on"]::before { animation: boAurora 9s linear infinite; will-change: transform; }
@keyframes boAurora { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { [data-aurora]::before { animation: none !important; } }
`;

export default function AuroraFrame({ children, radius = 21, width = 1, style }) {
    const reduced = useReducedMotion();
    if (IS_WEB) {
        injectCss('aurora', CSS);
        return (
            <View style={[{ borderRadius: radius, padding: width }, style]} dataSet={{ aurora: reduced ? 'still' : 'on' }}>
                {children}
            </View>
        );
    }
    return (
        <LinearGradient colors={['#6366F1', '#8B5CF6', '#34D399']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 1 }} style={[{ borderRadius: radius, padding: width }, style]}>
            {children}
        </LinearGradient>
    );
}
